<template>
    <modal :title="'Add Customer'" :size="'xl'" @close="$emit('close')">
        <template #content>
            <upsert @add="$emit('add',$event)" @close="$emit('close')"></upsert>
        </template>
    </modal>
</template>

<script>
    import upsert from "./upsert";
    export default {
        name:"add",
        components:{upsert}
    }
</script>

<style>

</style>